/** @jsxRuntime classic */
import 'blob.js';
import 'formdata-polyfill';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'abortcontroller-polyfill';
import * as Sentry from '@sentry/react';
import * as FullStory from '@fullstory/browser';

import { Integrations } from '@sentry/tracing';
// import 'fetch-polyfill';
// import 'abortcontroller-polyfill';
// import 'isomorphic-fetch';
// import 'webcrypto-shim/webcrypto-shim';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import Katapult from './Katapult';
import getStore from './redux/store';

const { store, persistor } = getStore();

const url = new URL(globalThis.location?.href);
let storisUid = url.searchParams.get('storis');

if (window.location.pathname === '/') {
  persistor.purge();
  localStorage.clear();
  if (storisUid) {
    if (/^[a-zA-Z0-9\-_.:]+$/.test(storisUid)) {
      localStorage.setItem('storisUid', storisUid);
    }
  }
} else {
  storisUid = localStorage.getItem('storisUid');
}

const renderApp = json => {
  const isProdOrSandbox = window.location.host.includes('sdk.katapult.com') || window.location.host.includes('sandbox');
  FullStory.init({
    orgId: '6QYDJ',
    recordCrossDomainIFrames: true,
    recordOnlyThisIFrame: true,
    devMode: !isProdOrSandbox,
  });
  ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Katapult window={window} json={json} />
      </PersistGate>
    </Provider>,
    document.getElementById('root'),
  );
};

if (storisUid) {
  renderApp({ offerToken: storisUid, integrationType: 'storis', token: '3c007be61d17302fd4e49ff26e2ed471f844dab4' });
}

window.addEventListener(
  'message',
  event => {
    if (event && event.data && event.data.message && event.data.message === 'set:cart') {
      if (window.location.host === 'sdk.katapult.com') {
        Sentry.init({
          dsn: 'https://6b9f10a49d52434fbbedaf8d74ebe19d@o16762.ingest.sentry.io/5679390',
          integrations: [new Integrations.BrowserTracing()],

          // Set tracesSampleRate to 1.0 to capture 100%
          // of transactions for performance monitoring.
          // We recommend adjusting this value in production
          tracesSampleRate: 1.0,
        });
      }
      const json = event.data.initialize;
      // eslint-disable-next-line no-console
      console.log('message', event.data.message);
      // eslint-disable-next-line no-console
      console.log('initialize', json);
      if (!json) {
        throw new Error('Initialize from postMessage is no valid');
      } else {
        renderApp(json);
      }
    }
  },
  false,
);

// Flows that boot from the query string alone, without a postMessage `set:cart` from a parent page.
const QUERY_STRING_FLOWS = ['synchrony', 'shopify', 'offerpage', 'instore_vcc'];
const DIRECT_PATHS = ['/order-completed'];
const isQueryStringFlow = QUERY_STRING_FLOWS.some(flow => window.location.search?.indexOf(flow) !== -1);
if (isQueryStringFlow || DIRECT_PATHS.includes(window.location.pathname)) {
  renderApp(null);
}
